import Vue from 'vue';
import Vuex from 'vuex';

import VueAxios from 'vue-axios';
import axios from 'axios';

import VueClipboard from 'vue-clipboard2';

import VueAuth from '@websanova/vue-auth';
import VueAuthRouter from 'middleware/router/vue-router.2.x';
import NuttremaAuthBearer from 'middleware/auth/bearer';
import NuttremaAuthAxios from 'middleware/http/axios';

import Filters from 'filters';

import { ObserveVisibility } from 'vue-observe-visibility';
import { ThemeManager } from 'services';


import NuttremaPermissionsControlWrapper from 'components/ui/permissions/nuttrema-permissions-control-wrapper';
import NuttremaEditLockButton from 'components/ui/button/nuttrema-edit-lock-button';

import { PERMISSIONS_GENERAL, PERMISSIONS_SUBSCRIBED_PLAN } from 'constants/permissions';

import LodashPrototypes from './lodash-prototypes';
import MarkdownPrototypes from './markdown-prototypes';

export const BeforeCreate = {
  init() {
    Vue.use(Vuex);

    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = process.env.API_URL;

    Vue.use(VueAuth, {
      rolesVar: 'scope',
      router: VueAuthRouter,
      http: NuttremaAuthAxios,
      auth: NuttremaAuthBearer,
      parseUserData(response) {
        return response;
      },
    });

    Vue.component('edit-lock-button', NuttremaEditLockButton);
    Vue.component('permissions-control-wrapper', NuttremaPermissionsControlWrapper);

    Vue.use(Filters);

    Vue.use(VueClipboard);

    // Add permision constants globally
    Vue.prototype.$PERMISSIONS_GENERAL = PERMISSIONS_GENERAL;
    Vue.prototype.$PERMISSIONS_SUBSCRIBED_PLAN = PERMISSIONS_SUBSCRIBED_PLAN;

    Vue.use(LodashPrototypes);
    Vue.use(MarkdownPrototypes);

    Vue.directive('observe-visibility', ObserveVisibility);

    // set theme
    ThemeManager.init();

    console.log('BeforeCreate init finish!');
  },
};



// WEBPACK FOOTER //
// ./src/init/before-create.js